import { SubscribersFilters } from './types';
import { FilterOption } from '../../../components/ui';

export const DEFAULT_FILTERS: SubscribersFilters = {
  search: '',
  account: '',
  campaign: '',
  campaignId: '',
  period: '',
  paidSubscription: false,
  paidSubscriptionAutoRenew: false,
  onePurchase: false,
  twoPurchases: false,
  fivePurchases: false,
  payments500: false,
  messages: false,
};

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_DELAY = 500;

export const getPeriodOptions = (t: (key: string) => string): FilterOption[] => [
  { key: '7days', label: t('partner.revshare.subscribers.filters.period7days') },
  { key: '14days', label: t('partner.revshare.subscribers.filters.period14days') },
  { key: '30days', label: t('partner.revshare.subscribers.filters.period30days') },
];

export const getCampaignTypeOptions = (t: (key: string) => string): FilterOption[] => [
  { key: 'all', label: t('global.common.all') || 'Все' },
  { key: 'cpl', label: 'CPL' },
  { key: 'refshare', label: 'RevShare' },
];

export const getTableColumns = (t: (key: string) => string) => [
  { name: 'ID', key: 'id' },
  { name: t('partner.revshare.subscribers.table.campaigns'), key: 'campaign' },
  { name: t('partner.revshare.subscribers.table.user'), key: 'user' },
  { name: t('partner.revshare.subscribers.table.income'), key: 'income' },
  { name: t('partner.revshare.subscribers.table.date'), key: 'date' },
];

export const getCampaignTypeColors = () => ({
  CPL: { bg: 'bg-[rgba(120,40,200,0.2)]', text: 'text-accent' },
  RevShare: { bg: 'bg-[rgba(120,40,200,0.2)]', text: 'text-accent' },
});
